const map = {
	"./": 7948,
	"./development": 1977,
	"./development.js": 1977,
	"./digital1amvne": 132,
	"./digital1amvne.js": 132,
	"./digital1bmvne": 9881,
	"./digital1bmvne.js": 9881,
	"./digital2bmvne": 5310,
	"./digital2bmvne.js": 5310,
	"./index": 7948,
	"./index.js": 7948,
	"./pasta": 4823,
	"./pasta.js": 4823,
	"./preview-dormant": 1260,
	"./preview-dormant.js": 1260,
	"./previewmvne": 5186,
	"./previewmvne.js": 5186,
	"./productionmvne": 3131,
	"./productionmvne.js": 3131,
	"./stagingmvne": 2975,
	"./stagingmvne.js": 2975,
	"./validate-staging-mvne": 5343,
	"./validate-staging-mvne.js": 5343
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4289;